import * as React from "react"
import { Command as CommandPrimitive } from "cmdk"
import { MagnifyingGlassIcon } from "@radix-ui/react-icons"

const Command = (props: React.ComponentProps<typeof CommandPrimitive>) => (
  <CommandPrimitive {...props} />
)
Command.displayName = CommandPrimitive.displayName

const CommandInput = (
  props: React.ComponentProps<typeof CommandPrimitive.Input>,
) => (
  <div className="flex items-center border-b px-3">
    <MagnifyingGlassIcon className="mr-2 h-4 w-4 shrink-0 opacity-50" />
    <CommandPrimitive.Input {...props} />
  </div>
)

CommandInput.displayName = CommandPrimitive.Input.displayName

const CommandInputUnstyled = (
  props: React.ComponentProps<typeof CommandPrimitive.Input>,
) => <CommandPrimitive.Input {...props} />

CommandInputUnstyled.displayName = CommandPrimitive.Input.displayName

const CommandList = (
  props: React.ComponentProps<typeof CommandPrimitive.List>,
) => <CommandPrimitive.List {...props} />

CommandList.displayName = CommandPrimitive.List.displayName

const CommandEmpty = (
  props: React.ComponentProps<typeof CommandPrimitive.Empty>,
) => <CommandPrimitive.Empty {...props} />

CommandEmpty.displayName = CommandPrimitive.Empty.displayName

const CommandGroup = (
  props: React.ComponentProps<typeof CommandPrimitive.Group>,
) => <CommandPrimitive.Group {...props} />

CommandGroup.displayName = CommandPrimitive.Group.displayName

const CommandSeparator = (
  props: React.ComponentProps<typeof CommandPrimitive.Separator>,
) => <CommandPrimitive.Separator {...props} />
CommandSeparator.displayName = CommandPrimitive.Separator.displayName

const CommandItem = (
  props: React.ComponentProps<typeof CommandPrimitive.Item>,
) => <CommandPrimitive.Item {...props} />

CommandItem.displayName = CommandPrimitive.Item.displayName

const CommandShortcut = (props: React.HTMLAttributes<HTMLSpanElement>) => (
  <span {...props} />
)
CommandShortcut.displayName = "CommandShortcut"

export {
  Command,
  CommandInput,
  CommandInputUnstyled,
  CommandList,
  CommandEmpty,
  CommandGroup,
  CommandItem,
  CommandShortcut,
  CommandSeparator,
}
